module.exports = __webpack_public_path__ + "img/r-17.044dd647.jpg";